import { createBrowserRouter } from 'react-router';

import { PortalLayout } from './components/layout/PortalLayout.js';
import { ProtectedRoute } from './components/layout/ProtectedRoute.js';
import { ContactsPage } from './pages/ContactsPage.js';
import { DocumentsPage } from './pages/DocumentsPage.js';
import { LoginPage } from './pages/LoginPage.js';
import { MyRequestsPage } from './pages/MyRequestsPage.js';
import { NewRequestPage } from './pages/NewRequestPage.js';
import { NewWorkOrderPage } from './pages/NewWorkOrderPage.js';
import { RequestDetailPage } from './pages/RequestDetailPage.js';
import { ServiceOrderDetailPage } from './pages/ServiceOrderDetailPage.js';
import { ServiceOrdersPage } from './pages/ServiceOrdersPage.js';
import { ServiceReportPage } from './pages/ServiceReportPage.js';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    element: (
      <ProtectedRoute>
        <PortalLayout />
      </ProtectedRoute>
    ),
    children: [
      // PM routes (also serves as landing for PMs)
      { index: true, element: <ServiceOrdersPage /> },
      { path: '/orders/:id', element: <ServiceOrderDetailPage /> },
      { path: '/reports/:id', element: <ServiceReportPage /> },
      { path: '/contacts', element: <ContactsPage /> },
      { path: '/work-order/new', element: <NewWorkOrderPage /> },
      { path: '/documents', element: <DocumentsPage /> },

      // Unit owner routes
      { path: '/my-requests', element: <MyRequestsPage /> },
      { path: '/my-requests/new', element: <NewRequestPage /> },
      { path: '/my-requests/:id', element: <RequestDetailPage /> },
    ],
  },
]);
